import logger from 'od-modules/utils/logger';
import fetcher from 'od-modules/utils/fetcher';
import tagManagement from 'od-modules/utils/tag_management.utils';
import stateSubscriber from './state_subscriber';

Odigeo.SessionScope.logger = logger;
Odigeo.SessionScope.fetcher = fetcher;
Odigeo.SessionScope.stateSubscriber = stateSubscriber;

Odigeo.on('jsLogger:disable', logger.disableLoggers);

Odigeo.on('analytics:tracking', function(event) {
    Odigeo.requireWidget('google-analytics', 'googleanalytics', function(widget) {
        widget.execute(event.type, event.data);
    });
});

Odigeo.on('tagCommander:pageLoaded', function(options) {
    tagManagement.updateAndExtendDatalayer({}, {
        page_name: options.page,
    });
});

Odigeo.on('tagCommander:fireEvent', function(options) {
    tagManagement.fireEvent(options.category, options.key, options.value);
});

Odigeo.on('frontend-shell:qualtrics', function(eventName) {
    tagManagement.fireExternalEvent('qualtrics', eventName);
});
